import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const createMedicineFormAPI = async ({ child, params }: { child: ChildrenStoreData, params: any }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.post(`/child/${child.childId}/medicine-form`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};

export const updateMedicineFormAPI = async ({ child, params, medicineFormID }: { child: ChildrenStoreData, params: any, medicineFormID: number }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;
    // retryAxios.defaults.headers.common['Content-Type'] = "application/json";

    return retryAxios.put(`/child/${child.childId}/medicine-form/${medicineFormID}`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};

export const getMedicineFormAPI = async ({ child, medicineFormID }: { child: ChildrenStoreData, medicineFormID: number }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/medicine-form/${medicineFormID}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response?.data?.medicineForm;
        }
        return null;
    });
};

export const signDosageAPI = async ({ child, medicineFormID, params }: { child: ChildrenStoreData, medicineFormID: number, params: { action: string, dosageIds?: number[], fileName?: string } }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;
    // retryAxios.defaults.headers.common['Content-Type'] = "application/json";

    return retryAxios.put(`/child/${child.childId}/medicine-form/${medicineFormID}/sign-dosage`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response?.data?.doses
        }
        return null;
    });
};